import { FormattedMessage } from "react-intl";
import CardInfo from "../CardInfo";
import Container from "./Container";
import { Col, Row } from "antd";

const ThirdBlock = ({ practiceEfficiency }) => {
  const children = (
    <>
      <Row gutter={16} align={"middle"} style={{ marginBottom: "15px" }}>
        <Col span={6}>
          <img src="/images/img-2.svg" alt="img" />
        </Col>
        <Col span={1} />
        <Col
          className="roi--patient-exp-acq-text roi--patient-exp-acq-text-2"
          span={8}
        >
          <span className="roi--patient-exp-acq-percentage">
            {practiceEfficiency?.braces?.percentage}%
          </span>
          <span>
            <FormattedMessage id="patientPratique" />
          </span>
          <span className="roi--patient-exp-acq-span">
            1 <FormattedMessage id="bracketDebond" />
          </span>
        </Col>
        <Col span={1} />
        <Col span={8}>
          <CardInfo
            topText={<FormattedMessage id="estimationPractice" />}
            mainNumber={Math.round(practiceEfficiency?.braces?.nb)}
            bottomText={<FormattedMessage id="bracketDebonded" />}
          />
        </Col>
      </Row>
      <Row gutter={16} align={"middle"}>
        <Col span={6}>
          <img src="/images/img-3.svg" alt="img" />
        </Col>
        <Col span={1} />
        <Col
          className="roi--patient-exp-acq-text roi--patient-exp-acq-text-2"
          span={8}
        >
          <span className="roi--patient-exp-acq-percentage">
            {practiceEfficiency?.aligners?.percentage}%
          </span>
          <span>
            <FormattedMessage id="patientAligners" />
          </span>
          <span className="roi--patient-exp-acq-span">
            1 <FormattedMessage id="attachmentDebond" />
          </span>
        </Col>
        <Col span={1} />
        <Col span={8}>
          <CardInfo
            topText={<FormattedMessage id="estimationPractice" />}
            mainNumber={Math.round(practiceEfficiency?.aligners?.nb)}
            bottomText={<FormattedMessage id="attchementlost" />}
          />
        </Col>
      </Row>
    </>
  );
  return (
    <Container
      blockTitle={"didyouknow"}
      title={"why"}
      content={"efficiencyPatientInfo"}
      children={children}
    />
  );
};

export default ThirdBlock;
